export default __webpack_public_path__ + "static/media/patient1.5758cce6.png";